import { render } from "./ProductInformation.vue?vue&type=template&id=e271eb50&scoped=true&ts=true"
import script from "./ProductInformation.vue?vue&type=script&lang=ts"
export * from "./ProductInformation.vue?vue&type=script&lang=ts"

import "./ProductInformation.vue?vue&type=style&index=0&id=e271eb50&lang=css"
import "./ProductInformation.vue?vue&type=style&index=1&id=e271eb50&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e271eb50"]])

export default __exports__